import { render, staticRenderFns } from "./AppIndex.vue?vue&type=template&id=73a72e5c"
import script from "./AppIndex.vue?vue&type=script&lang=ts"
export * from "./AppIndex.vue?vue&type=script&lang=ts"
import style0 from "./AppIndex.vue?vue&type=style&index=0&id=73a72e5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports